import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.currentPath = window.location.pathname;
    this.applyActiveState();
  }

  applyActiveState() {
    this.linkTargets.forEach((link) => {
      const itemPath = link.dataset.pathValue;

      let isActive = false;

      if (itemPath === "/console") {
        isActive = this.currentPath === "/console";
      } else {
        isActive = this.currentPath.startsWith(itemPath);
      }

      const activeClasses =
        "bg-sidebar-primary text-sidebar-primary-foreground";
      const inactiveClasses =
        "text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground";
      const baseClasses =
        "flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors";

      if (isActive) {
        link.className = `${baseClasses} ${activeClasses}`;
      } else {
        link.className = `${baseClasses} ${inactiveClasses}`;
      }
    });
  }
}
